<script setup lang="ts">
import { computed } from 'vue';
import store from '@/store';
import { useFonts } from '@/composables/fonts';
import FontSelector from '../FontSelector.vue';
import type { CSelectItem, Primitive } from '@/components/shared/CSelect';
import { findFontByUrl, fontUrlFromPath } from './calendarUtils';

const props = defineProps<{
    /** Absolute font url as stored in the calendar config. */
    value?: string;
    disabled?: boolean;
}>();

const emit = defineEmits<{
    (e: 'input', value: string): void;
}>();

const { generateFontName } = useFonts();

const selected = computed<CSelectItem<string> | undefined>(() => {
    const font = findFontByUrl(store.state.userFonts, props.value);
    return font ? { label: generateFontName(font), value: font.Path } : undefined;
});

const onFontSelected = (item?: CSelectItem<Primitive>) => {
    if (!item?.value) return;
    emit('input', fontUrlFromPath(String(item.value)));
};
</script>

<template>
    <font-selector :value="selected" :disabled="disabled" @input="onFontSelected" />
</template>
